import React from "react";
import { Link } from "react-router-dom";
import { useDocumentHead } from "../hooks/useDocumentHead";

/**
 * Soft-404 fallback. True HTTP 404 requires edge/host config — a static SPA
 * cannot return a 404 status code. We signal "not found" to crawlers via
 * <meta name="robots" content="noindex,follow"> so the page is excluded from
 * search results.
 */
export default function NotFoundPage() {
    useDocumentHead({
        title: "Page Not Found | GrowCo Motion",
        description: "The page you were looking for doesn't exist. Head back to GrowCo Motion to see our work.",
        canonical: "https://growcomotion.com/",
        robots: "noindex,follow",
    });

    return (
        <main
            style={{
                minHeight: "100vh",
                background: "var(--bg)",
                color: "var(--text)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "48px 24px",
                textAlign: "center",
                gap: 24,
            }}
        >
            <p
                style={{
                    color: "var(--accent)",
                    textTransform: "uppercase",
                    letterSpacing: "0.3em",
                    fontSize: 13,
                    margin: 0,
                }}
            >
                404 — Not Found
            </p>
            <h1
                style={{
                    fontSize: "clamp(2.4rem, 6vw, 5rem)",
                    lineHeight: 1,
                    letterSpacing: "-0.03em",
                    margin: 0,
                    fontWeight: 900,
                    textTransform: "uppercase",
                }}
            >
                This page took a different path.
            </h1>
            <p style={{ maxWidth: 560, color: "var(--muted)", fontSize: 18, lineHeight: 1.6, margin: 0 }}>
                The URL you tried doesn't exist on GrowCo Motion. Everything that moves is still over on the homepage.
            </p>
            <Link
                to="/"
                data-testid="notfound-home-link"
                style={{
                    marginTop: 8,
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "12px 24px",
                    borderRadius: 999,
                    border: "2px solid var(--line)",
                    color: "var(--text)",
                    textDecoration: "none",
                    textTransform: "uppercase",
                    letterSpacing: "0.2em",
                    fontSize: 14,
                }}
            >
                Back to Home
            </Link>
        </main>
    );
}
